import { ErrorPrivateView } from '@/features/errors'

export const PrivateErrorView = () => {
  return <ErrorPrivateView />
}
